module.exports = __webpack_public_path__ + "static/img/gjsc4.e720279.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/gjsc4.jpg
// module id = HNVe
// module chunks = 0